/**
 * undefinedか否か
 * @param val {*}
 * @return {Boolean}
 * *
 */
export const isUndefined = (val) => typeof val === 'undefined';

/**
 * 数値か否か（null と Infinity は数値扱いしない）
 * @param val
 * @returns {boolean}
 */
export const isNumber = (val)=>{
    return typeof val === 'number' && Number.isFinite(val)
}

/**
 * 文字列か否か
 * @str {*}
 * @returns {boolean}
 */
export const isString = (str)=>{
    return str != null && typeof str.valueOf() === "string";
}

/**
 * 数値に変換し、変換できない場合は undefined を返す
 * null / undefined / '' も undefined 扱い
 * @param val
 * @returns {number|undefined} */
export const toNumberOrUndefined = (val) => {
    if (val == null || val === '') return undefined;
    const n = Number(val);
    return Number.isFinite(n) ? n : undefined;
}
